export default __webpack_public_path__ + "static/media/Anglais.77dc9bee.png";